module.exports = {};


/*****************
 ** WEBPACK FOOTER
 ** ./~/.2.4.1@core-js/library/modules/_iterators.js
 ** module id = 52
 ** module chunks = 0 1
 **/